import { apiUrl, get, post } from '@modules/api/src/API';

import {
  Danji2DFacilityData,
  Danji3DFacilityData,
  DanjiAroundData,
  DanjiData,
  DanjiDecalData,
  DanjiDongData,
  DanjiDongHoData,
  DanjiHoModelData,
  DanjiItemIds,
  DanjiUnitPresalePriceData,
  DanjiUnitPriceData,
  DanjiUnitPublicPriceData,
  ItemData,
  UnitDetailData,
} from './APIResponse';

export const getDecalMaskURL = (danjiId: string) => {
  return `${apiUrl}zed/danji/${danjiId}/decal_image`;
};

export const getEnviromentMaskURL = (danjiId: string, width: number = 4096) => {
  const qp = width == 4096 ? '' : `?width=${width}`;
  return `${apiUrl}zed/danji/${danjiId}/decal/all${qp}`;
};

export const getDanjiDong = async (danjiId: string) => {
  return await get<DanjiDongData[]>(`${apiUrl}zed/danji/${danjiId}/dong`);
};

export const getDanji = async (danjiId: string) => {
  return await get<DanjiData>(`${apiUrl}danji/${danjiId}`);
};

export const getItemIds = async (danjiId: string) => {
  return await get<number[]>(`${apiUrl}items/ids?areaDanjiId=${danjiId}&isIncludeNoVRItems=true&isIncludeLocalAgentItems=true`);
};

export const postItems = async (danjiIds: number[]) => {
  const danjiItemIds: DanjiItemIds = {
    itemIds: danjiIds,
  };

  return await post<ItemData[]>(`${apiUrl}items`, danjiItemIds);
};

export const get2DFeature = async (danjiId: string) => {
  return await get<Danji2DFacilityData[]>(`${apiUrl}zed/danji/${danjiId}/2dfeature_json`);
};

export const get3DFeature = async (danjiId: string) => {
  return await get<Danji3DFacilityData[]>(`${apiUrl}zed/danji/${danjiId}/3dfeature_json`);
};

export const getDanjiDongHo = async (danjiId: string, buildingId: number) => {
  return await get<DanjiDongHoData>(`${apiUrl}zed/danji/${danjiId}/dong/${buildingId}/ho`);
};

export const getAround = async (danjiId: string, distance: number, appVersion: string, domain: string) => {
  return await get<DanjiAroundData>(
    `${apiUrl}zed/danji/${danjiId}/around?distance=${distance}&appVersion=${appVersion}&domain=${domain}`
  );
};

export const getDecal = async (danjiId: string) => {
  return await get<DanjiDecalData>(`${apiUrl}zed/danji/${danjiId}/decal_json`);
};

export const getDanjiHoModel = async (danjiId: string, roomTypeId: number, hoId: number) => {
  return await get<DanjiHoModelData>(`${apiUrl}zed/danji/${danjiId}/room_type/${roomTypeId}/ground_plan?hoId=${hoId}`);
};

export const getUnitDetail = async (hoId: string | number) => await get<UnitDetailData>(`${apiUrl}ho/${hoId}`);

/**
 * 직방 시세
 */
export const getDanjiUnitPrice = async (areaBuildingId: number) =>
  get<DanjiUnitPriceData>(`${apiUrl}building/${areaBuildingId}/zigbangprice`);

/**
 * 공시가
 */
export const getDanjiUnitPublicPrice = async (areaBuildingId: number) =>
  get<DanjiUnitPublicPriceData>(`${apiUrl}building/${areaBuildingId}/publicprice`);

/**
 * 분양가
 */
export const getDanjiUnitPresalePrice = async (areaBuildingId: number) =>
  get<DanjiUnitPresalePriceData>(`${apiUrl}building/${areaBuildingId}/presaleprice`);

/** @deprecated Use getDanjiUnitPrice instead */
export const getDanjiHoPrice = getDanjiUnitPrice;
/** @deprecated Use geDanjiUnitPublicPrice instead */
export const getDanjiHoPublicPrice = getDanjiUnitPublicPrice;
/** @deprecated Use geDanjiUnitPresalePrice instead */
export const getDanjiHoPresalePrice = getDanjiUnitPresalePrice;
